import Checkbox from 'components/Globals/Base/Checkbox';
import type { EventData } from 'services/Gtm/entities';
import {
  CrashCourseFilterSectionWrapper,
  OptionsGroup,
  OptionsGroupLabel,
  OptionsGroupWrapper,
} from './CrashCoursesFilterSectionStyles';

export interface FilterSection {
  key: string;
  title: string;
  options: {
    checked: boolean;
    title: string;
    value: string;
  }[];
}

export interface FilterValue {
  [key: string]: string | undefined;
}

export interface CrashCourseFiltersSectionProps {
  filters: FilterSection[];
  onChange: (value: FilterValue, checked: boolean) => void;
  inDropdown?: boolean;
  trackingData?: EventData;
}

const CrashCourseFilterSection = ({
  filters,
  onChange,
  inDropdown = false,
  trackingData,
}: CrashCourseFiltersSectionProps) => (
  <CrashCourseFilterSectionWrapper $inDropdown={inDropdown}>
    {filters.map(({ title: sectionTitle, key: sectionKey, options }) => (
      <OptionsGroup key={sectionTitle}>
        <OptionsGroupLabel
          $inDropdown={inDropdown}
          data-cy='crashCourseFiltersTitle'
        >
          {sectionTitle}
        </OptionsGroupLabel>
        <OptionsGroupWrapper>
          {options.map(({ value: optionValue, title: optionTitle, checked }) => (
            <li key={optionValue}>
              <Checkbox
                dataCy='crashCourseComplexityCheckbox'
                className='checkbox'
                key={optionValue}
                name={optionValue}
                value={checked}
                trackingData={trackingData}
                onChange={() => onChange({ [sectionKey]: optionValue }, !checked)}
              >
                {optionTitle}
              </Checkbox>
            </li>
          ))}
        </OptionsGroupWrapper>
      </OptionsGroup>
    ))}
  </CrashCourseFilterSectionWrapper>
);

export default CrashCourseFilterSection;
